import * as actionTypes from './actionTypes'

export const processShowModal = (options) => (dispatch) =>
  dispatch({ type: actionTypes.PROCESS_SHOW_MODAL, payload: { options } })
